import React from 'react';
import _ from 'lodash';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { ToastStatus } from '@wix/design-system/dist/types/StatusToast/StatusToast.types';
import StatusToastNotification from '@components/StatusToastNotification';

export type PurchaseErrorNotificationProps = {
  isMobileView?: boolean;
  isError: boolean;
  setPurchaseError: (isError: boolean) => void;
  isViewer?: boolean;
};

function PurchaseErrorNotification({
  isMobileView,
  isError,
  setPurchaseError,
  isViewer,
}: PurchaseErrorNotificationProps) {
  const { t } = useTranslation();

  const commonProps = {
    show: isError,
    key: 'purchase-error',
    status: 'error' as ToastStatus,
    duration: 5000,
    dataHook: 'purchase-error',
    message: t('marketplace.template-purchase-error'),
    isMobileView,
  };

  const toastProps = isMobileView
    ? commonProps
    : {
        ...commonProps,
        dismissible: true,
        onDismiss: () => setPurchaseError(false),
      };

  return <StatusToastNotification {...toastProps} />;
}

export default PurchaseErrorNotification;
